import { render, staticRenderFns } from "./CustomerPauses.vue?vue&type=template&id=36c9400c&scoped=true"
import script from "./CustomerPauses.vue?vue&type=script&lang=js"
export * from "./CustomerPauses.vue?vue&type=script&lang=js"
import style0 from "./CustomerPauses.vue?vue&type=style&index=0&id=36c9400c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c9400c",
  null
  
)

export default component.exports